/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PodIdRegexQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("PodIdRegexQueryOperator");
    }

    getFixupPrototypeFunction() { return PodIdRegexQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<PodIdRegexQueryOperator>): PodIdRegexQueryOperator {
        let obj = Object.assign(new PodIdRegexQueryOperator(), model);
        PodIdRegexQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PodIdRegexQueryOperator>): PodIdRegexQueryOperator {
        if (!model) return null;
        return PodIdRegexQueryOperator.newInstance(<PodIdRegexQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PodIdRegexQueryOperator) {
        if (!obj) return;

        models.PodIdRegexQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PodIdRegexQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, PodIdRegexQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.pod_id_regex) {
            models.Regex.fixupPrototype(this.pod_id_regex);
        }
    }

    /**
     * Kubernetes Pod ID by regex match (resource_id, resource_group=Pod)
     */
    pod_id_regex: models.Regex;

}
